var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 48,
    viewBox: "0 0 276 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_167_90",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.412109H47.7964V47.9998H0V0.412109Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_167_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4521 12.8374L0.00939941 48.0017H12.4573L15.5095 39.5635L18.9908 29.3718L13.4521 12.8374ZM29.6046 0.413086H18.285L23.8036 15.956L23.8103 15.9365L31.9843 39.5635L35.0956 48.0017H47.7867L29.6046 0.413086Z",
    fill: "#CC2D2D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9455 46.923H75.7981L69.7707 38.368L63.7433 46.923H52.5958L64.1969 30.461L52.9847 14.5176H64.1321L69.7707 22.5541L75.4092 14.5176H86.5567L75.3444 30.461L86.9455 46.923Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.86 47.8303C92.3324 47.8303 84.6847 40.3771 84.6847 30.7203C84.6847 21.0635 92.3324 13.6103 101.86 13.6103C111.387 13.6103 119.034 21.0635 119.034 30.7203C119.034 40.3771 111.387 47.8303 101.86 47.8303ZM101.86 38.368C106.072 38.368 109.313 35.3218 109.313 30.7203C109.313 26.1187 106.072 23.0726 101.86 23.0726C97.6469 23.0726 94.4063 26.1187 94.4063 30.7203C94.4063 35.3218 97.6469 38.368 101.86 38.368Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.883 13.6103C166.336 13.6103 171.197 18.9247 171.197 27.0261V46.923H161.475V27.8686C161.475 24.6281 159.92 22.5541 156.809 22.5541C153.568 22.5541 151.754 24.8225 151.754 28.6463V46.923H142.032V27.8686C142.032 24.6281 140.477 22.5541 137.366 22.5541C134.125 22.5541 132.311 24.8225 132.311 28.6463V46.923H122.589V14.5176H132.311V17.4989C133.801 15.2953 136.653 13.6103 140.995 13.6103C144.819 13.6103 147.671 15.1657 149.485 17.8878C151.3 15.2953 154.281 13.6103 158.883 13.6103Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.759 11.6659C177.583 11.6659 174.926 9.00869 174.926 5.83297C174.926 2.65724 177.583 0 180.759 0C183.935 0 186.592 2.65724 186.592 5.83297C186.592 9.00869 183.935 11.6659 180.759 11.6659ZM175.898 46.923V14.5176H185.62V46.923H175.898Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.723 14.5176H221.445V46.923H211.723V43.8769C209.974 46.2749 206.733 47.8303 202.456 47.8303C195.91 47.8303 190.336 43.1639 190.336 34.4145V14.5176H200.057V32.9887C200.057 37.0069 202.585 38.8864 205.696 38.8864C209.261 38.8864 211.723 36.8125 211.723 32.2109V14.5176Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.924 13.6103C270.378 13.6103 275.238 18.9247 275.238 27.0261V46.923H265.517V27.8686C265.517 24.6281 263.961 22.5541 260.85 22.5541C257.61 22.5541 255.795 24.8225 255.795 28.6463V46.923H246.074V27.8686C246.074 24.6281 244.518 22.5541 241.407 22.5541C238.167 22.5541 236.352 24.8225 236.352 28.6463V46.923H226.63V14.5176H236.352V17.4989C237.843 15.2953 240.694 13.6103 245.037 13.6103C248.86 13.6103 251.712 15.1657 253.527 17.8878C255.342 15.2953 258.323 13.6103 262.924 13.6103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.ed61e78e5086f5bf3d5855774fac2b52.svg";
export { ForwardRef as ReactComponent };